"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.differenceDays = exports.getMinDate = exports.getMaxDate = exports.getDateTime = exports.addHours = exports.addDays = exports.secondsToDhms = exports.ruleThree = exports.getDaysMonth = exports.getSeconds = exports.getMinutes = exports.getHours = exports.getDay = exports.getMonth = exports.getYear = exports.isString = exports.convertTimeToWidthSpace = exports.formatTime = exports.checkCurrentHour = exports.getHourByTime = exports.calculateTime = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @param {number} value valor a sustraer o sumar
 * @param {number} multiply multiplo que aumenta o disminuye el rango de las lineas en el timeline
 * @param {string} unit el tipo de unidad (hrs o dias)
 * @description calcula el encabezado de las líneas del timeline
 */
var calculateTime = function calculateTime(value, multiply, unit) {
  var hour = (0, _moment["default"])();

  if (value > 0) {
    hour.add(value * multiply, unit);
  } else {
    hour.subtract(-value * multiply, unit);
  }

  return hour;
};

exports.calculateTime = calculateTime;

var getHourByTime = function getHourByTime(time) {
  return parseInt(time.split(':')[0], 10);
};

exports.getHourByTime = getHourByTime;

var checkCurrentHour = function checkCurrentHour(time) {
  var hour = getHourByTime(time);
  var currentHour = new Date().getHours();
  return hour === currentHour;
}; // TODO: check the change of time (?)


exports.checkCurrentHour = checkCurrentHour;

var formatTime = function formatTime(value) {
  var hour = value / 100;
  var stringValue = value.toString();

  if (hour < 10) {
    return "0".concat(stringValue.charAt(0), ":").concat(stringValue.charAt(1) || '0').concat(stringValue.charAt(2) || '0');
  }

  return "".concat(stringValue.charAt(0)).concat(stringValue.charAt(1), ":").concat(stringValue.charAt(2)).concat(stringValue.charAt(3));
};
/**
 * @author Juan de Dios
 * @description transform a integer representation of time to base 100
 * @param {Number} n integer time
 * @param {Number} space base of width space
 */


exports.formatTime = formatTime;

var convertTimeToWidthSpace = function convertTimeToWidthSpace(n) {
  var space = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  if (!n) return 0;
  return n % space !== 0 ? n - n % space + n % space * space / 60 : n;
};

exports.convertTimeToWidthSpace = convertTimeToWidthSpace;

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};

exports.isString = isString;

var getYear = function getYear(date) {
  return new Date(date).getFullYear();
};

exports.getYear = getYear;

var getMonth = function getMonth(date) {
  return new Date(date).getMonth();
};

exports.getMonth = getMonth;

var getDay = function getDay(date) {
  return new Date(date).getDay();
};

exports.getDay = getDay;

var getHours = function getHours(date) {
  return new Date(date).getHours();
};

exports.getHours = getHours;

var getMinutes = function getMinutes(date) {
  return new Date(date).getMinutes();
};

exports.getMinutes = getMinutes;

var getSeconds = function getSeconds(date) {
  return new Date(date).getSeconds();
};

exports.getSeconds = getSeconds;

var getDaysMonth = function getDaysMonth(date) {
  return new Date(getYear(date), getMonth(date), 0).getDate();
};

exports.getDaysMonth = getDaysMonth;

var ruleThree = function ruleThree(a, b) {
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  return base * a / b;
};

exports.ruleThree = ruleThree;

var secondsToDhms = function secondsToDhms(time) {
  var days = Math.floor(time / (3600 * 24));
  var hours = Math.floor(time % (3600 * 24) / 3600);
  var minutes = Math.floor(time % 3600 / 60);
  var seconds = Math.floor(time % 60);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    total: days + hours + minutes + seconds
  };
};

exports.secondsToDhms = secondsToDhms;

var addDays = function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

exports.addDays = addDays;

var addHours = function addHours(date, h) {
  var result = new Date(date);
  result.setTime(result.getTime() + h * 60 * 60 * 1000);
  return result;
};

exports.addHours = addHours;

var getDateTime = function getDateTime(beginDate, type, columnQuantity) {
  var results = [];

  switch (type) {
    case 'DAY':
      for (var i = 0; i < columnQuantity; i++) {
        var nextDay = new Date(beginDate);
        nextDay.setDate(beginDate.getDate() + i);
        results.push(nextDay);
      }

      break;

    case 'HOUR':
      var hour = beginDate.getHours();

      for (var _i = 0; _i < columnQuantity; _i++) {
        if (hour <= 24) {
          hour += 1;
        }

        if (hour >= 24) {
          hour = 0;
        }

        results.push(hour);
      }

      break;

    default:
      for (var _i2 = 1; _i2 <= columnQuantity; _i2++) {
        var _nextDay = new Date(beginDate);

        _nextDay.setDate(beginDate.getDate() + _i2);

        results.push(_nextDay);
      }

      break;
  }

  return results;
};

exports.getDateTime = getDateTime;

var getMaxDate = function getMaxDate(details) {
  var result = Math.max.apply(Math, _toConsumableArray(details.map(function (o) {
    return o.end;
  }))); // return moment(result).format('YYYY-MM-DD');

  return result;
};

exports.getMaxDate = getMaxDate;

var getMinDate = function getMinDate(details) {
  var result = Math.min.apply(Math, _toConsumableArray(details.map(function (o) {
    return o.begin;
  }))); // return moment(result).format('YYYY-MM-DD');

  return result;
};

exports.getMinDate = getMinDate;

var differenceDays = function differenceDays(startDate, endDate) {
  var date_format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD';

  var getDateAsArray = function getDateAsArray(date) {
    return (0, _moment["default"])(date.split(/\D+/), date_format);
  };

  return getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') === 0 ? 1 : getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days');
};

exports.differenceDays = differenceDays;